export {
	getOnboardingDraftStorageKey,
	ONBOARDING_DRAFT_MAX_AGE_MS,
	ONBOARDING_DRAFT_VERSION,
	type OnboardingDraftValue,
} from "@/app/onboarding/_lib/draft";
export {
	extractFriendlyName,
	getAgeFromDateOfBirth,
} from "@/app/onboarding/_lib/helpers";
export {
	mapOnboardingSchemaErrors,
	onboardingSchema,
} from "@/app/onboarding/_lib/schema";
export {
	DEFAULT_ONBOARDING_VALUES,
	genderSchema,
	type OnboardingFormFieldName,
	type OnboardingFormValues,
	type OnboardingValidationErrors,
	profileVisibilitySchema,
} from "@/app/onboarding/_lib/types";
export {
	INDIAN_PHONE_DIGITS,
	normalizeIndianPhone,
	sanitizeIndianPhoneInput,
} from "@/lib/shared/phone";
